import * as React from "react";
import * as i from "../../../../../contracts";
import { CardPropsHandlers } from "../../../../../typings";
import { renderFavoritesIcon } from "../../EventCard";
import { renderEventName } from "../../LiveOutright/RenderMethods";

export const renderMiniOutrightDetails = (event: i.Event, handlers: CardPropsHandlers, showFavorites: boolean, componentPrefix: string) => {
    const classNames = `rj-ev-list__${componentPrefix}__section rj-ev-list__${componentPrefix}__event-info`;

    return (
        <a href={event.linkUrl}
            onClick={handlers.eventCard}
            className={classNames}
            key={`${componentPrefix}__event-info__${event.id}`}
            data-uat="event-details">

            <div className={`rj-ev-list__${componentPrefix}__section-item rj-ev-list__${componentPrefix}__names`} data-uat={`div-ev-list-${componentPrefix}-names`}>
                {renderEventName(event, componentPrefix)}
            </div>

            {showFavorites && renderFavoritesIcon(event.isInFavorites, handlers.favorites)}
        </a>
    );
};